import { render, staticRenderFns } from "./Song.vue?vue&type=template&id=367f0ffd&scoped=true"
import script from "./Song.vue?vue&type=script&lang=js"
export * from "./Song.vue?vue&type=script&lang=js"
import style0 from "./Song.vue?vue&type=style&index=0&id=367f0ffd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367f0ffd",
  null
  
)

export default component.exports